import { COPIA_TOMADA, cuandoSeTomo } from '../lib/copia-de-tienda.js';
import { useT } from '../i18n/index.js';

/**
 * A copy of the real shop saying it is not the shop (`pnpm copia`, `lib/copia-de-tienda.ts`).
 *
 * On the home screen under the sync status, and on the setup screen a copy's newly enrolled
 * device lands on first, since it has no till of its own. Nothing, anywhere else.
 */
export function AvisoCopiaDeTienda() {
  const t = useT();
  if (!COPIA_TOMADA) return null;
  return (
    <p className="rounded-lg bg-sky-500/10 px-3 py-2 text-xs text-sky-200">
      {t('copiaDeTienda.aviso', { cuando: cuandoSeTomo(COPIA_TOMADA) })}
    </p>
  );
}
